import { fontFamily, fontSize } from "@mui/system";
import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { SIZES } from "theme";

const Dropdown = ({small, setSelectedVehicle}) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("HiLoadEV");

  const toggleList = () => {
    setIsListOpen(!isListOpen);
  };

  const selectItem = (item) => {
    setSelectedItem(item);
    setIsListOpen(false);
    setSelectedVehicle(item)
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box background="#1C1C1C" b={small ? "none" : "1px solid #333333"}>
        <Text
          style={{ fontSize: "16px", paddingLeft: "20px" }}
          fontWeight="bold"
          textColor="white"
        >
          Select Vehicle
        </Text>
        <div style={styles.dropdownWrapper}>
          <button style={styles.dropdownHeader} onClick={toggleList}>
            <div style={styles.dropdownHeaderTitle}>{selectedItem}</div>
            <span
              style={{
                ...styles.arrow,
                ...(isListOpen ? styles.arrowUp : styles.arrowDown),
              }}
            ></span>
          </button>
          {isListOpen && (
            <ul style={styles.dropdownList}>
              {["HiLoadEV", "StormEV"].map((item) => (
                <li
                  key={item}
                  style={styles.dropdownListItem}
                  onClick={() => selectItem(item)}
                >
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Box>
    </Box>
  );
};

const styles = {
  dropdownWrapper: {
    width: "auto",
    paddingLeft: "20px",
    position: "relative",
    paddingRight: "20px",
    paddingBottom: "20px",
    fontFamily: "Arial, sans-serif",
  },
  dropdownHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "white",
    border: "1px solid #ccc",
    width: "100%",

    cursor: "pointer",
  },
  dropdownHeaderTitle: {
    fontSize: "16px",
    color: "black",
    fontWeight: "bold",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: "6px solid black",
    transition: "transform 0.3s",
  },
  arrowUp: {
    transform: "rotate(180deg)",
  },
  arrowDown: {},
  dropdownList: {
    position: "absolute",
    width: "92%",

    backgroundColor: "white",
    border: "1px solid #ccc",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    marginTop: "5px",
    zIndex: "10",
    padding: "0",
    listStyleType: "none",
  },
  dropdownListItem: {
    padding: "10px",

    cursor: "pointer",
    fontFamily: "Archia",
    color: "black",
    backgroundColor: "#fff",
    borderBottom: "1px solid #ccc",
  },
};

export default Dropdown;
